/**
 * Cycle custom du header-slider — Bootstrap n'est PAS utilisé pour
 * l'autoplay : on gère toute la séquence en JS pour avoir un vrai effet
 * "cross-dissolve via black" type montage vidéo.
 *
 * À chaque tick :
 *   1. add .is-fading       → overlay 0 → 1 sur FADE_DURATION_MS
 *   2. wait FADE_DURATION_MS → écran complètement noir/blanc
 *   3. swap .active         → le slide suivant prend la main (cut instantané,
 *                             invisible car masqué par l'overlay)
 *   4. remove .is-fading    → overlay 1 → 0 sur FADE_DURATION_MS
 *   5. wait l'interval      → puis on recommence
 *
 * L'overlay et sa couleur (noir/blanc selon le thème) sont gérés côté SCSS.
 * La durée du fade côté CSS (.6s) doit rester synchronisée avec FADE_DURATION_MS.
 */
const FADE_DURATION_MS = 600
const DEFAULT_INTERVAL_MS = 3000

/**
 * Préchauffe les <img> des slides non-actifs APRÈS le 1er paint.
 *
 * Les <img> non-1er sont en loading="lazy" → tant qu'ils restent en
 * display:none, le browser ne résout PAS leur srcset et ne fetch rien.
 * Au 1er swap d'active, il faut alors résoudre srcset + fetch + decode,
 * et currentSrc reste vide quelques frames (image manquante visuellement).
 *
 * On bascule donc loading="eager" via JS (idle callback) : le browser
 * résout srcset, fetch et décode l'image dès qu'il a du temps libre,
 * sans pénaliser le LCP du 1er paint.
 */
const preloadSlideImages = (slider) => {
  const imgs = Array.from(
    slider.querySelectorAll('.carousel-item:not(.active) img[loading="lazy"]')
  )

  const preload = () => {
    imgs.forEach((img) => {
      img.loading = 'eager'
    })
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(preload, {
      timeout: 2000
    })
  } else {
    setTimeout(preload, 1500)
  }
}

const initHeaderSliderFade = () => {
  const sliders = document.querySelectorAll('.header-slider.carousel')
  if (!sliders.length) {
    return
  }

  sliders.forEach((slider) => {
    const items = Array.from(slider.querySelectorAll('.carousel-item'))
    if (items.length < 2) {
      return
    }

    const interval = parseInt(slider.dataset.slideInterval || '', 10) || DEFAULT_INTERVAL_MS
    let currentIdx = items.findIndex((el) => el.classList.contains('active'))
    if (currentIdx < 0) {
      currentIdx = 0
      items[0].classList.add('active')
    }

    preloadSlideImages(slider)

    const nextSlide = () => {
      slider.classList.add('is-fading')

      setTimeout(() => {
        items[currentIdx].classList.remove('active')
        currentIdx = (currentIdx + 1) % items.length
        items[currentIdx].classList.add('active')
        slider.classList.remove('is-fading')
      }, FADE_DURATION_MS)
    }

    setInterval(nextSlide, interval)
  })
}

if (document.readyState !== 'loading') {
  initHeaderSliderFade()
} else {
  document.addEventListener('DOMContentLoaded', initHeaderSliderFade)
}
